// extracted by mini-css-extract-plugin
module.exports = {"datewrap":"dates_datewrap__3KGKi","date":"dates_date__1ZmfE","weekday":"dates_weekday__3Y1TY","range":"dates_range__32H5A"};